<template>
    <div id="library-left-container">
        <div style="text-align: left; ">

            <div class="row">
                <div style="width: 100%; margin-bottom: 20px;">
                    <small class="sans-font-style" style="color: #536170; vertical-align: sub;">{{lang("Library")}}
                    </small>

                    <el-tooltip class="item" effect="dark"
                                content="No size limit but if files size large take longer time!" placement="top">

                        <button class="btn sans-font-style btn-upload"
                                style="background: #426DFF; border-radius: 5px; color: #ffffff; float: right; padding: 6px 20px;"
                                id="v-step-libraryUpload"
                                @click="onclickUploadFile()">
                            {{lang("Upload")}}
                        </button>

                    </el-tooltip>

                    <input type="file" id="fileUpload" multiple hidden="hidden"/>
                </div>

                <div class="input-group" style="width: 100%;">
                    <input class="form-control library-search" type="text" :placeholder="lang('Search Library')"
                           v-model="searchFilesTag" @keyup="searchFiles($event)" id="v-step-librarySearch"/>
                    <div class="input-group-append" style="cursor: pointer;" @click="searchFiles()">
                        <span class="btn btn-library-search-icon">
                            <i class="fa fa-search"></i>
                        </span>
                    </div>
                </div>

                <div v-if="isSearch">
                    <small v-if="searchFilesTag !== ''" style="color: #91A3B6;">{{lang("Search")}}
                        "{{searchFilesTag}}"
                    </small>
                </div>
            </div>

            <div class="row" v-if="!isSearch">
                <div style="width: 100%;">
                    <small class="sans-font-style" style="color: #536170;">{{lang("Select Directory")}}</small>

                    <div style="float:right;" id="v-step-moreAction">
                        <el-popover
                                v-model="isVisible"
                                placement="bottom"
                                width="100"
                                trigger="click"
                                popper-class="library__dropdown">
                            <button class="btn btn-link" style="color: #ffffff;" @click="showCreateModal">
                                {{lang("Create New Folder")}}
                            </button>
                            <button class="btn btn-link" style="color: #ffffff;" @click="showMoveModal">
                                {{lang("Move")}}
                            </button>
                            <button class="btn btn-link" style="color: #ffffff;" @click="showRemoveModal">
                                {{lang("Delete")}}
                            </button>
                            <button class="btn btn-link" style="color: #ffffff;" @click="showViewModal">
                                {{lang("View")}}
                            </button>
                            <button class="btn btn-link" style="color: #ffffff;" @click="downloadItem">
                                {{lang("Download")}}
                            </button>
                            <!--                            <button class="btn btn-link" style="color: #ffffff;" @click="showRenameModal">{{lang("Rename")}}</button>-->
                            <!--                            <el-button id="single-post-dropdown" slot="reference">-->
                            <small id="single-post-dropdown-1" style="color: #426DFF; float: right; cursor: pointer;"
                                   slot="reference">
                                <i class="fa fa-ellipsis-h" style="font-size: 18px;"></i>
                            </small>
                            <!--                            </el-button>-->
                        </el-popover>
                    </div>

                </div>

                <div style="width: 100%;">
                    <el-breadcrumb separator-class="el-icon-arrow-right" style="margin: 5px 0px;">
                        <el-breadcrumb-item v-for="(obj_Folder,i) of arrobj_FolderPath"
                                            :key="obj_Folder.GalID">
                            <span style="font-weight: bold; cursor: pointer;"
                                  @click="backSpecificDirectory(obj_Folder,i)">
                                {{obj_Folder.GalFolder}}
                            </span>
                        </el-breadcrumb-item>
                    </el-breadcrumb>

                    <div class="">
                        <select class="form-control" v-model="selectedFolder"
                                @change="changeSelectedFolder()" style="background: #F8FAFF; font-size: 14px;">
                            <option v-for="obj_Folder of arrobj_Folders"
                                    :key="obj_Folder.GalID"
                                    :data-type="obj_Folder.GalType" :value="obj_Folder">
                                <i class="fa fa-angle-right" style="color: #ACB3C0; margin-right: 5px;"></i>
                                <img src="../assets/Vector9.png"/>
                                <span style="margin-left: 10px">{{obj_Folder.GalFolder}}</span>
                            </option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="row" v-show="currentPage === 'moment'">
                <button class="btn sans-font-style btn-moment-editor-file" style="margin-left: auto;"
                        @click="grapeSelectedFiles()">
                    {{lang("Move To Editor")}}
                </button>
            </div>

            <div class="row library-list-container">

                <div class="files-list-container" style="width: 100%;" v-if="arrobj_Files.length > 0">
                    <div class="media-file" v-for="obj_File of arrobj_Files" :key="obj_File.GalID"
                         style="vertical-align: top;">

                        <label :for="obj_File.GalID" class="media-file-image-container" draggable="true">
                            <img class="media-file-image"
                                 v-if="isImage(obj_File)"
                                 :src="obj_File.FilePath" :alt="obj_File.GalFileName" draggable="false"/>

                            <!--                            <LazyVideo class="media-file-image" v-if="isVideo(obj_File)" style="max-width: 100%;"-->
                            <!--                                       :src="obj_File.FilePath" />-->

                            <div class="nonM card-img-top d-block img-fluid w-100"
                                 :class="'video-thumbnail-'+obj_File.GalID"
                                 v-else-if="isVideo(obj_File)" @click="triggerClickVideo(obj_File, obj_File.GalID)">
                                <img class="nonM card-img-top d-block img-fluid w-100"
                                     style="object-fit: contain; height: 100%;"
                                     src="../assets/video-thumbnail.jpg"/>
                            </div>

                            <!--                            <video class="media-file-image" style="max-width: 100%;" preload="none" v-if="isVideo(obj_File)"-->
                            <!--                                   controls :poster="obj_File.videoThumbnail" controlsList="nodownload">-->
                            <!--                                <source :src="obj_File.FilePath"-->
                            <!--                                        type="video/mp4">-->
                            <!--                            </video>-->

                            <audio class="media-file-image" v-if="isAudio(obj_File)" controls style="max-width: 100%;">
                                <source :src="obj_File.FilePath"
                                        :alt="obj_File.GalFileName">
                            </audio>

                            <pdf class="media-file-image"
                                 v-if="!isImage(obj_File) && !isVideo(obj_File) && !isAudio(obj_File) && obj_File.GalFileExt.toLowerCase() === '.pdf'"
                                 :src="obj_File.FilePath" style="max-width: 100%; overflow: auto;"></pdf>
                        </label>

                        <input class="limited" type="checkbox" hidden="hidden" :id="obj_File.GalID" :value="obj_File"
                               v-model="arrobj_SelectedItem"
                               :disabled="isNull(arrobj_SelectedItem.find(x=>x.GalID === obj_File.GalID)) && arrobj_SelectedItem.length >= int_SelectLimit"/>
                        <label :for="obj_File.GalID"></label>

                        <span v-if="obj_File.FileFullPath && searchFilesTag !== ''" style="font-size: 12px;">{{obj_File.FileFullPath}}</span>
                    </div>
                </div>

                <div v-if="isSearch && arrobj_Files.length <= 0">
                    <h4>{{lang("Not found related files")}}</h4>
                </div>
            </div>

            <!--            <hr v-if="(currentPage === 'feed' || currentPage === 'broadcast')" />-->

            <!--            <div class="row" v-if="arrobj_SelectedItem.length > 0">-->
            <!--                <div style="width: 100%;">-->
            <!--                    <small class="sans-font-style" style="color: #536170;">{{lang("Added to post")}}</small>-->
            <!--                </div>-->

            <!--                <div class="selected-files-container">-->
            <!--                    <div v-for="(obj_File, fileIndex) in arrobj_SelectedItem" style="display: inline-block;">-->
            <!--                        <img class="selected-file"-->
            <!--                             v-if="isImage(obj_File)"-->
            <!--                             :src="obj_File.FilePath" :alt="obj_File.GalFileName" draggable="false"/>-->

            <!--                        <LazyVideo class="selected-file" v-if="isVideo(obj_File)" :src="obj_File.FilePath" />-->

            <!--                        <audio class="selected-file" v-if="isAudio(obj_File)" controls>-->
            <!--                            <source :src="obj_File.FilePath"-->
            <!--                                    :alt="obj_File.GalFileName">-->
            <!--                        </audio>-->

            <!--                        <pdf class="selected-file" v-if="!isImage(obj_File) && !isVideo(obj_File) && !isAudio(obj_File) && obj_File.GalFileExt.toLowerCase() === '.pdf'"-->
            <!--                             :src="obj_File.FilePath"></pdf>-->
            <!--                    </div>-->
            <!--                </div>-->
            <!--            </div>-->

            <!--            v-if="(currentPage === 'feed' || currentPage === 'broadcast')" userType === 'Principal' || userType === 'Course Leader'-->
            <div class="row" style="margin: 10px 0px;"
                 v-if="(currentPage === 'feed' || (currentPage === 'broadcast' && (usrMenuItem === 'CreateBroadcast') ) )">
                <div class="create-post-title" style="width: 100%;">
                    <div style="display: inline-block; vertical-align: sub;">
                        <img src="../assets/Vector8.png"/>
                        <span class="sans-font-style-different-size" v-if="currentPage === 'feed'"
                              style="vertical-align: middle;">
                            {{lang("Create")+lang("Post")}}</span>

                        <span class="sans-font-style-different-size" v-if="currentPage === 'broadcast'"
                              style="vertical-align: middle;">
                            {{lang("Create")+lang("Broadcast")}}</span>
                    </div>

                    <button class="btn sans-font-style btn-publish"
                            @click="showModalType()">{{lang("Post")}}
                    </button>
                </div>
            </div>

        </div>

        <b-modal id="modal_PostComponents" hide-footer size="lg" @hidden="hideComponentModal"
                 :title="str_PostComponentTitle" ref="modal_PostComponent">
            <component @result="displayResult"
                       :is="obj_SelectedComponent"
                       :images="arrobj_SelectedItem"
                       :paramCurrentPage="currentPage"></component>
        </b-modal>

        <b-modal id="modal_NewFolder" :title="lang('New')+''+lang('Folder')" ref="modal_NewFolder" centered
                 :ok-title="lang('Create')"
                 @ok="createFolder" @keyup.enter.native="createFolder" :cancel-title="lang('Cancel')">
            <div class="form-group">
                <input type="text" maxlength="25" ref="tb_FolderName" class="form-control" id="tb_FolderName"
                       v-model="str_NewFolderName"
                       :placeholder="lang('Please enter folder name')" autocomplete="off" autofocus/>
            </div>
        </b-modal>

        <b-modal id="modal_FilesTag" title="Tag Files" ref="modal_FilesTag" centered :ok-title="lang('Confirm')"
                 @ok="uploadFiles(arrobj_SelectedFiles)" :cancel-title="lang('Cancel')">
            <div class="col-md-4" v-for="selFile in arrobj_SelectedFiles" style="display: inline-block;">
                <div style="text-align: center;">
                    <img v-if="checkFilesType(selFile).toLowerCase() === 'image'"
                         :src="selFile.url"
                         style="height: 200px; width: 200px;">

                    <LazyVideo v-if="checkFilesType(selFile).toLowerCase() === 'video'"
                               :src="selFile.url"
                               style="height: 200px; width: 200px;"/>

                    <audio v-if="checkFilesType(selFile).toLowerCase() === 'audio'" controls
                           style="height: 200px; width: 200px;">
                        <source :src="selFile.url">
                    </audio>

                    <pdf v-if="selFile.type === 'application/pdf'"
                         :src="selFile.url"
                         style="height: 200px; width: 200px; overflow: auto;"></pdf>

                    <div>
                        <el-input
                                v-model="selFile.FileText"
                                type="text"
                                placeholder="File Text">
                        </el-input>
                    </div>
                </div>
            </div>
        </b-modal>

        <b-modal id="modal_MoveItem" :title="lang('Move To')" ref="modal_MoveItem" centered @ok="MoveItems"
                 :ok-title="lang('OK')" :cancel-title="lang('Cancel')">

            <div class="row modal_MoveItem-buttonGroup">
                <div class="col-lg-4">

                    <el-button type="primary" id="btn_MoveModalPrevious" @click="MoveModalGoBack"
                               v-if="arrobj_MoveModalFolderPath.length > 1">
                        <i class="el-icon-house"></i>
                        {{lang("Back")}}
                    </el-button>

                    <div v-for="obj_MoveModalFolder of arrobj_MoveModalFolders"
                         :key="obj_MoveModalFolder.GalID"
                         :data-type="obj_MoveModalFolder.GalType">
                        <el-button type="primary" @click="MoveModalChangeDirectory(obj_MoveModalFolder)">
                            <i class="el-icon-folder"></i>
                            {{obj_MoveModalFolder.GalFolder}}
                            <i class="el-icon-arrow-right   "></i>
                        </el-button>
                    </div>
                </div>
                <div class="col-lg-8">

                    <div class="modal_MoveItem-slider">
                        <b-carousel id="carousel2"
                                    style="text-shadow: 1px 1px 2px #333;"
                                    controls
                                    indicators
                                    background="#ababab"
                                    :interval="0"
                        >
                            <b-carousel-slide v-for="obj_Item of arrobj_SelectedItem" :key="obj_Item.FileID">
                                <img slot="img" :src="obj_Item.FilePath"
                                     :alt="obj_Item.GalFileName"/>
                            </b-carousel-slide>
                        </b-carousel>
                    </div>
                </div>
            </div>
        </b-modal>

        <b-modal id="modal_RemoveItem" :title="lang('Remove')" ref="modal_RemoveItem" centered
                 :ok-title="lang('Confirm')"
                 @ok="removeItems" :cancel-title="lang('Cancel')">
            <div class="form-group">
                <div v-if="obj_ContextTarget != null && arrobj_SelectedItem.length > 0">
                    {{lang("Are you sure you want to delete the folder and the selected image(s)")}}
                </div>
                <div v-else-if="obj_ContextTarget == null && arrobj_SelectedItem.length > 0">
                    {{lang("Please confirm you want to delete the selected media")}}
                </div>
                <div v-else-if="obj_ContextTarget != null && arrobj_SelectedItem.length === 0">
                    {{lang("Are you sure you want to remove the folder")}}
                </div>
            </div>
        </b-modal>

        <b-modal id="modal_ViewItem" :title="lang('View')" ref="modal_ViewItem" centered ok-only
                 :ok-title="lang('Close')">
            <b-carousel id="carousel1"
                        style="text-shadow: 1px 1px 2px #333;"
                        controls
                        indicators
                        background="#ababab"
                        :interval="4000"
                        v-model="slide"
                        @sliding-start="onSlideStart"
                        @sliding-end="onSlideEnd"
            >
                <b-carousel-slide v-for="obj_Item of filteredSelectedItem" :key="obj_Item.FileID">
                    <img slot="img" class="d-block img-fluid w-100" v-if="isImage(obj_Item)"
                         :src="obj_Item.FilePath" :alt="obj_Item.GalFileName"/>

                    <LazyVideo slot="img" class="d-block img-fluid w-100" v-if="isVideo(obj_Item)"
                               :src="obj_Item.FilePath"/>

                    <span>{{obj_Item.GalFileName}}</span>
                </b-carousel-slide>
            </b-carousel>
        </b-modal>

        <b-modal id="modal_RenameFolder" :title="lang('Rename')+''+lang('Folder')" ref="modal_RenameFolder" centered
                 :ok-title="lang('Rename')"
                 @ok="renameFolder" @keyup.enter.native="renameFolder">
            <div class="form-group">
                <input type="text" maxlength="25" ref="tb_RenameFolder" class="form-control" id="tb_RenameFolder"
                       v-model="str_NewFolderName"
                       :placeholder="lang('New')+''+lang('Folder')+''+lang('Name')" autocomplete="off" autofocus/>
            </div>
        </b-modal>

        <v-tour name="LibraryPageVueTourName" :steps="libraryPageVueTour" :options="libraryPageVueTourOptions"
                :callbacks="libraryPageVueTourCallBacks">
            <template slot-scope="tour">
                <transition name="fade">
                    <v-step
                            v-if="tour.currentStep === index"
                            v-for="(step, index) of tour.steps"
                            :key="index"
                            :step="step"
                            :previous-step="tour.previousStep"
                            :next-step="tour.nextStep"
                            :stop="tour.stop"
                            :is-first="tour.isFirst"
                            :is-last="tour.isLast"
                            :labels="tour.labels"
                    >
                        <template v-if="tour.currentStep > 1 && tour.currentStep < index">
                            <div slot="actions">
                                <button class="v-step__button" @click="tour.stop">Skip tour</button>
                                <button class="v-step__button" @click="tour.previousStep">
                                    Previous
                                </button>
                                <button class="v-step__button" @click="tour.nextStep">Next</button>
                            </div>
                        </template>
                    </v-step>
                </transition>
            </template>
        </v-tour>

        <div v-if="checkMobileStatus" style="position: fixed; z-index: 999; bottom: 50px; width: 100%;">
            <button class="btn sans-font-style--size-12" style="background: #426DFF; color: #ffffff; width: 100%;"
                    @click="mobileLibraryBack()">{{lang("Back")}}
            </button>
        </div>
    </div>
</template>

<script>
    import DataSource from "../data/datasource";
    import {lang} from '../locale/index';
    import Cookies from "js-cookie";
    import $ from 'jquery';
    import pdf from 'vue-pdf';
    import Vue from 'vue';
    import VueLazyLoadVideo from 'vue-lazyload-video';

    Vue.use(VueLazyLoadVideo);

    import updates from "../components/Post_Updates_Component.vue";
    import broadcast from "../components/Post_Broadcast_Component.vue";
    import globalFn from "../components/GlobalFn.vue";
    import heic2any from "heic2any";

    export default {
        name: "MainLibraryComponent",
        components: {
            pdf,
        },
        data() {
            return {
                arrstr_Whitelist: [],
                arrobj_Folders: [],
                arrobj_Files: [],
                arrobj_FolderPath: [{GalFolder: lang("Library"), GalID: "PRIMARY", GalType: "Folder"}],
                arrobj_SelectedItem: [],
                arrobj_SelectedFiles: [],
                arr_SelectedFileList: [],
                arr_searchFileList: [],
                arrobj_MoveModalFolders: [],
                arrobj_MoveModalFolderPath: [],

                obj_ContextTarget: {},
                selectedFolder: {},
                obj_ComponentProperties: {},

                int_StartRowNo: 1,
                int_EndRowNo: 20,
                int_SelectLimit: 30,
                slide: 0,

                searchFilesTag: '',
                obj_SelectedComponent: '',
                str_PostComponentTitle: '',
                currentPage: '',
                str_NewFolderName: '',
                userType: '',

                isVisible: false,
                isSearch: false,
                checkMobileStatus: false,

                //vue tour
                //https://github.com/pulsardev/vue-tour
                libraryPageVueTourOptions: {
                    useKeyboardNavigation: false,
                    labels: {
                        buttonSkip: 'Skip tour',
                        buttonPrevious: 'Previous',
                        buttonNext: 'Next',
                        buttonStop: 'Finish'
                    }
                },
                libraryPageVueTourCallBacks: {
                    onPreviousStep: this.libraryPageVueTourCallBacksPreviousSteps,
                    onNextStep: this.libraryPageVueTourCallBacksNextSteps
                },
                libraryPageVueTour: [
                    {
                        target: '#v-step-moreAction',
                        content: `<div class="libraryPageTourDiv">Step 1 / 7 <br> Click Create New Folder button <br> Then enter folder name and click Create button.</div>`,
                        params: {
                            placement: 'left',
                            enableScrolling: false
                        }
                    },
                    {
                        target: '#v-step-libraryUpload',
                        content: `<div class="libraryPageTourDiv">Step 2 / 7 <br> Click Upload button <br> Then select image(s).</div>`,
                        params: {
                            placement: 'bottom',
                            enableScrolling: false
                        }
                    },
                    {
                        target: '#v-step-moreAction',
                        content: `<div class="libraryPageTourDiv">Step 3 / 7 <br> Select uploaded file(s) and click Move button <br> Then choose where you want to move to and click Ok button.</div>`,
                        params: {
                            placement: 'left',
                            enableScrolling: false
                        }
                    },
                    {
                        target: '#v-step-moreAction',
                        content: `<div class="libraryPageTourDiv">Step 4 / 7 <br> Select uploaded file(s) and click Delete button <br> Then click Confirm button.</div>`,
                        params: {
                            placement: 'left',
                            enableScrolling: false
                        }
                    },
                    {
                        target: '#v-step-moreAction',
                        content: `<div class="libraryPageTourDiv">Step 5 / 7 <br> Select uploaded file(s) and click View button.</div>`,
                        params: {
                            placement: 'left',
                            enableScrolling: false
                        }
                    },
                    {
                        target: '#v-step-moreAction',
                        content: `<div class="libraryPageTourDiv">Step 6 / 7 <br> Select uploaded file(s) and click Download button.</div>`,
                        params: {
                            placement: 'left',
                            enableScrolling: false
                        }
                    },
                    {
                        target: '#v-step-librarySearch',
                        content: `<div class="libraryPageTourDiv">Step 7 / 7 <br> Enter keywords and press enter for search.</div>`,
                        params: {
                            placement: 'bottom',
                            enableScrolling: false
                        }
                    },
                ],
                //vue tour

                usrMenuItem: "",
            };
        },
        props: ["changeCurrentPage"],
        created() {
            this.userType = Cookies.get('userTypeSession');
            this.usrMenuItem = Cookies.get('subMenuItem');

            window.addEventListener('resize', this.isMobile);
        },
        destroyed() {
            $(window).unbind('scroll');

            window.removeEventListener('resize', this.isMobile);
        },
        computed: {},
        methods: {
            lang,

            /*#region load whitelist (check which files format can upload)*/
            loadWhitelist() {
                this.arrstr_Whitelist = [];

                DataSource.shared.getWhitelist().then((result) => {
                    if (result.Table) {
                        this.arrstr_Whitelist = result.Table;
                    }
                });
            },

            isWhitelist(file) {
                let temparrstr = file.name.split(".");
                let str_Ext = ("." + temparrstr[temparrstr.length - 1]).toUpperCase();
                let isWhitelisted = this.arrstr_Whitelist.findIndex(x => x.ext.toUpperCase() === str_Ext) !== -1;
                let isValidFile = file.size > 0;

                return (isWhitelisted && isValidFile);
            },
            /*#endregion*/

            /*#region init load/get folder and files*/
            initFolder(obj_Folder) {
                this.arrobj_Files = [];
                this.arrobj_Folders = [];
                this.arrobj_SelectedItem = [];
                this.arr_searchFileList = [];
                this.int_StartRowNo = 1;
                this.int_EndRowNo = 20;

                this.getFolders(obj_Folder).then((result) => {
                    this.arrobj_Folders = result;
                });
                this.loadFiles(obj_Folder);
            },

            getFolders(obj_Folder) {
                return new Promise((resolve, reject) => {
                    DataSource.shared.getFolders(obj_Folder.GalID).then((result) => {
                        let temp = [];
                        if (result.code != 2 && result.code != 99)
                            temp = result.Table;

                        resolve(temp);
                    });
                });
            },

            loadFiles(obj_Folder) {
                this.getFiles(obj_Folder).then((result) => {

                    // if (!this.isNull(result)) {
                    //     result.forEach((loadedFiles, loadedIndex) => {
                    //         if (this.isVideo(loadedFiles)) {
                    //             var thumbnail = this.generateVideoThumbnail(loadedFiles.FilePath);
                    //             loadedFiles.videoThumbnail = thumbnail;
                    //         }
                    //     });
                    // }

                    this.arrobj_Files.push.apply(this.arrobj_Files, result);
                }).then(() => {
                    this.hideLoading();
                });
            },

            getFiles(obj_Folder) {
                this.showLoading();
                return new Promise((resolve, reject) => {
                    DataSource.shared.getFiles(obj_Folder.GalID, this.int_StartRowNo, this.int_EndRowNo, this.searchFilesTag).then((result) => {
                        let arr_Result;

                        // if (result.code === "2") {

                        // }

                        if (result.code !== "2" && result.code !== "99") {
                            arr_Result = result.Table;

                            this.int_StartRowNo = this.int_EndRowNo + 1;
                            this.int_EndRowNo = this.int_EndRowNo + 20;
                        }
                        resolve(arr_Result);
                    });
                });
            },
            /*#endregion*/

            /*#region upload files with files tag*/
            onclickUploadFile() {
                $("#fileUpload").val("");
                $("#fileUpload").click();
            },

            showFilesTagModal() {
                for (let a = 0; a < this.arr_SelectedFileList.length; a++) {
                    if (this.isWhitelist(this.arr_SelectedFileList[a])) {

                    } else {
                        this.$notify.error({
                            title: 'Error',
                            message: 'File with invalid format selected!'
                        });
                        return;
                    }
                }

                this.changeSelectedFilesFormat();
                this.$refs.modal_FilesTag.show();
            },

            hideFilesTagModal() {
                this.$refs.modal_FilesTag.hide();
            },

            async changeSelectedFilesFormat() {
                // this.showLoading();
                this.arrobj_SelectedFiles = [];
                for (let a = 0; a < this.arr_SelectedFileList.length; a++) {

                    var blobUrl = URL.createObjectURL(this.arr_SelectedFileList[a]);

                    if (this.arr_SelectedFileList[a].name.toLowerCase().indexOf(".heic") !== -1) {
                        this.showLoading();

                        await this.heicToJpeg(this.arr_SelectedFileList[a]).then((convertedFile) => {
                            this.arrobj_SelectedFiles.push(convertedFile);
                        }).finally(() => {
                            this.hideLoading();
                            // this.arrobj_SelectedFiles.push(this.arr_SelectedFileList[a]);
                        });
                    } else {
                        this.arrobj_SelectedFiles.push(this.arr_SelectedFileList[a]);
                    }

                    // this.arrobj_SelectedFiles.push(this.arr_SelectedFileList[a]);
                }
                await this.convertSelectedFilesToFileFormat();
            },

            convertSelectedFilesToFileFormat() {
                this.convertedFileForInsert = [];
                this.arrobj_SelectedFiles.forEach(async (images) => {
                    if (images.name === undefined) {
                        let url = "data:" + images.type + ";base64," + images.EventFileOriginal;
                        let fileName = images.EventFIleName;
                        let mimeType = images.EventFileType;
                        this.urltoFile(url, fileName, mimeType).then((file) => {
                            this.convertedFileForInsert.push(file);
                        }).finally(() => {
                            // this.getImagePreviews();
                        });
                    } else {

                        // images.url = URL.createObjectURL(images);

                        if (!this.isNull(images.url)) {
                            // if (images.name.toLowerCase().indexOf(".heic") !== -1) {

                        } else {
                            images.url = URL.createObjectURL(images);
                        }

                        // images.url = URL.createObjectURL(images);
                    }
                });

                // console.log(this.arrobj_SelectedFiles, "list");
                this.hideLoading();
            },

            async heicToJpeg(val) {
                var blobUrl = URL.createObjectURL(val);

                return await fetch(blobUrl)
                    .then((res) => res.blob())
                    .then((blob) => heic2any({
                        blob,
                        toType: "image/jpeg",
                        quality: 1
                    }))
                    .then((conversionResult) => {
                        var url = URL.createObjectURL(conversionResult);
                        conversionResult.name = val.name.replace('.heic', '.jpeg');
                        conversionResult.url = url;
                        conversionResult.oriType = "heic";
                        return conversionResult;
                    })
                    .catch((e) => {
                        console.log(e);
                        return e;
                    });
            },

            urltoFile(url, filename, mimeType) {
                return (fetch(url)
                        .then(function (res) {
                            return res.arrayBuffer();
                        })
                        .then(function (buf) {
                            return new File([buf], filename, {type: mimeType});
                        })
                );
            },

            checkFilesType(eachfile) {
                let fileType = eachfile.type.split("/");

                if (fileType[0] === "") {
                    fileType[0] = "image";
                }

                return fileType[0];
            },

            async uploadFiles(filesUploaded) {
                this.$vs.loading();
                await this.sleep(500);

                if (filesUploaded.length > 0) {
                    try {
                        let obj_CurrentFolder = this.arrobj_FolderPath[this.arrobj_FolderPath.length - 1];

                        let arrobj_AcceptedFiles = [];

                        for (let file of filesUploaded) {

                            if (file.oriType === "heic") {
                                var convertedF = new File([file], file.name, {
                                    type: file.type,
                                    lastModified: new Date()
                                });
                                file = convertedF;
                            }

                            if (this.isWhitelist(file))
                                arrobj_AcceptedFiles.push(file);
                        }

                        const saveResponse = await DataSource.shared.saveFile(arrobj_AcceptedFiles, obj_CurrentFolder.GalID)
                            .then(async (result) => {
                                // await this.$vs.loading.close();
                                await this.hideLoading();
                                await this.initFolder(obj_CurrentFolder);
                            });
                    } catch (e) {
                        console.log(e);
                    }
                } else {

                }

                await this.sleep(500);
                this.hideLoading();
            },
            /*#endregion*/

            /*#region check files type*/
            isImage(obj_File) {
                let ext = String(obj_File.GalFileExt).toUpperCase();
                let isImage = false;

                switch (ext) {
                    case ".PNG":
                    case ".JPG":
                    case ".BMP":
                    case ".GIF":
                    case ".JPEG":
                        isImage = true;
                        break;
                    default:
                        isImage = false;
                        break;
                }

                return isImage;
            },

            isVideo(obj_File) {
                let ext = String(obj_File.GalFileExt).toUpperCase();
                let isVideo = false;

                switch (ext) {
                    case ".MP4":
                    case ".MOV":
                        isVideo = true;
                        break;
                    default:
                        isVideo = false;
                        break;
                }

                return isVideo;
            },

            isAudio(obj_File) {
                let ext = String(obj_File.GalFileExt).toUpperCase();
                let isAudio = false;

                switch (ext) {
                    case ".MP3":
                    case ".AAC":
                    case ".WAV":
                    case ".M4A":
                        isAudio = true;
                        break;
                    default:
                        isAudio = false;
                        break;
                }

                return isAudio;
            },

            globalCheckFileType(obj_File) {
                // var globalCheck = await this.globalCheckFileType(obj_File);
                // if (globalCheck === "IMAGES") {
                //     isImage = true;
                // }

                return globalFn.WhiteListExt(String(obj_File.GalFileExt).toLowerCase());
            },
            /*#endregion*/

            /*#region Create Folder Functions*/
            showCreateModal() {
                this.isVisible = false;
                this.$refs.modal_NewFolder.show();
            },
            hideCreateModal() {
                this.$refs.modal_NewFolder.hide();
            },
            createFolder() {
                if (this.str_NewFolderName == null)
                    return;

                let obj_CurrentFolder = this.arrobj_FolderPath[this.arrobj_FolderPath.length - 1],
                    str_NewFolderName = this.str_NewFolderName;

                this.showLoading();
                DataSource.shared.createFolder(obj_CurrentFolder.GalID, str_NewFolderName).then((result) => {
                    this.initFolder(obj_CurrentFolder);
                    this.str_NewFolderName = "";
                    this.hideLoading();
                    this.hideCreateModal();
                });
            },
            /*#endregion*/

            /*#region Move Item Functions*/
            showMoveModal() {
                this.isVisible = false;
                this.$refs.modal_MoveItem.show();
                this.arrobj_MoveModalFolderPath = [];
                this.arrobj_MoveModalFolderPath.push.apply(this.arrobj_MoveModalFolderPath, this.arrobj_FolderPath);
                let obj_CurrentFolder = this.arrobj_MoveModalFolderPath[this.arrobj_MoveModalFolderPath.length - 1];

                this.MoveModalInitFolder(obj_CurrentFolder);
            },

            hideMoveModal() {
                this.$refs.modal_MoveItem.hide();
            },

            MoveModalGoBack() {
                if (this.arrobj_MoveModalFolderPath.length >= 1)
                    this.arrobj_MoveModalFolderPath.pop();
                if (this.arrobj_MoveModalFolderPath.length > 0) {
                    let obj_PreviousFolder = this.arrobj_MoveModalFolderPath[this.arrobj_MoveModalFolderPath.length - 1];
                    this.MoveModalInitFolder(obj_PreviousFolder);
                }
            },

            MoveModalChangeDirectory(obj_Folder) {
                this.arrobj_MoveModalFolderPath.push(obj_Folder);
                this.MoveModalInitFolder(obj_Folder);
            },

            MoveModalInitFolder(obj_Folder) {
                this.arrobj_MoveModalFolders = [];

                this.getFolders(obj_Folder).then((result) => {
                    this.arrobj_MoveModalFolders = result;
                    this.hideLoading();
                });
            },

            MoveItems() {
                this.showLoading();

                let arr_Promises = [];
                let obj_TargetFolder = this.arrobj_MoveModalFolderPath[this.arrobj_MoveModalFolderPath.length - 1];

                for (let obj_ItemToMove of this.arrobj_SelectedItem)
                    arr_Promises.push(DataSource.shared.moveFile(obj_ItemToMove.GalID, obj_TargetFolder.GalID));

                Promise.all(arr_Promises).then(() => {
                    this.hideLoading();
                    this.initFolder(this.arrobj_FolderPath[this.arrobj_FolderPath.length - 1]);
                });
            },
            /*#endregion*/

            /*#region Remove Item Functions*/
            showRemoveModal() {
                this.isVisible = false;
                this.$refs.modal_RemoveItem.show();
            },
            hideRemoveModal() {
                this.$refs.modal_RemoveItem.hide();
            },
            removeItems() {
                this.showLoading();

                let arrstr_IDToRemove = [];
                let arr_Promises = [];

                if (this.arrobj_SelectedItem.length === 0) {
                    arrstr_IDToRemove.push(this.arrobj_FolderPath[this.arrobj_FolderPath.length - 1].GalID);
                    let lastIndex = this.arrobj_FolderPath.length - 1;
                    this.arrobj_FolderPath.splice(lastIndex, 1);
                }

                if (this.obj_ContextTarget != null)
                    arrstr_IDToRemove.push(this.obj_ContextTarget.id);

                for (let obj_SelectedItem of this.arrobj_SelectedItem)
                    arrstr_IDToRemove.push(obj_SelectedItem.GalID);

                for (let str_IDToRemove of arrstr_IDToRemove) {
                    arr_Promises.push(DataSource.shared.removeFile(str_IDToRemove));
                }

                Promise.all(arr_Promises).then(() => {
                    this.isClickedRemove = false;
                    this.hideLoading();

                    if (this.arrobj_FolderPath.length > 0) {
                        this.initFolder(this.arrobj_FolderPath[this.arrobj_FolderPath.length - 1]);
                    } else {
                        this.arrobj_FolderPath = [{GalFolder: lang("Library"), GalID: "PRIMARY", GalType: "Folder"}];
                        this.initFolder(this.arrobj_FolderPath[0]);
                    }
                    // this.initFolder(this.arrobj_FolderPath[this.arrobj_FolderPath.length - 1]);
                });

                /*if (i === itemsToRemove.length)
                    this.initFolder(this.filteredFolderPath[this.filteredFolderPath - 1]);*/
            },
            /*#endregion*/

            /*#region View Item Functions*/
            showViewModal() {
                this.isVisible = false;
                this.$refs.modal_ViewItem.show();
            },
            hideViewModal() {
                this.$refs.modal_ViewItem.show();
            },

            /*#region Carousel Slider*/
            onSlideStart(slide) {
                this.sliding = true;
            },
            onSlideEnd(slide) {
                this.sliding = false;
            },
            /*endregion*/
            /*#endregion*/

            /*#region Rename Item Functions*/
            showRenameModal() {
                this.isVisible = false;
                this.$refs.modal_RenameFolder.show();
            },
            hideRenameModal() {
                this.$refs.modal_RenameFolder.hide();
            },
            renameFolder() {
                if (this.str_NewFolderName == null)
                    return;

                let obj_CurrentFolder = this.arrobj_FolderPath[this.arrobj_FolderPath.length - 1],
                    obj_TargetFolder = this.obj_ContextTarget,
                    str_NewFolderName = this.str_NewFolderName;

                // DataSource.shared.renameFile(obj_TargetFolder.id, str_NewFolderName).then((result) => {
                DataSource.shared.renameFile(obj_CurrentFolder.GalID, str_NewFolderName).then((result) => {
                    this.showLoading();
                }).then(() => {
                    this.initFolder(obj_CurrentFolder);
                    this.arrobj_FolderPath[this.arrobj_FolderPath.length - 1].GalFolder = this.str_NewFolderName;
                    this.str_NewFolderName = "";
                    this.obj_ContextTarget = {};
                    this.hideLoading();
                });
            },
            /*#endregion*/

            /*#region Download Item Functions*/
            async downloadItem() {
                let arr_Promises = [];
                this.showLoading();
                for (let obj_SelectedItem of this.arrobj_SelectedItem) {
                    let downloadPromise = new Promise((resolve, reject) => {
                        DataSource.shared.downloadFile(obj_SelectedItem.GalID).then((result) => {
                            let response = result.Table[0];

                            var indexA = 1;
                            this.urltoFile(obj_SelectedItem.FilePath, obj_SelectedItem.GalFileName, obj_SelectedItem.GalFileType).then((blobFile) => {
                                var url = window.URL.createObjectURL(blobFile);
                                // var img = new Image();
                                let a = document.createElement("a");
                                if (url) {
                                    a.href = url;
                                } else {
                                    a.href = obj_SelectedItem.FilePath;
                                }
                                a.target = "_blank";
                                a.download = ("download-" + indexA + obj_SelectedItem.GalFileExt).toString();
                                a.style.display = "none";
                                document.body.appendChild(a);
                                a.click();
                                a.remove();
                                indexA++;
                            });
                            resolve(result);
                        });
                    });

                    arr_Promises.push(downloadPromise);
                }

                Promise.all(arr_Promises).then((result) => {
                    this.hideLoading();
                });
            },
            getContentType(e) {
                let contentType = "";

                switch (e.GalFileExt.toUpperCase()) {
                    case ".PDF":
                        contentType += "application/octet-stream";
                        break;
                    default:
                        contentType += e.GalFileType;
                        break;
                }

                return contentType;
            },
            b64toBlob(b64Data, contentType, sliceSize) {
                //Credit to Jeremy Banks @ stackoverflow
                contentType = contentType || '';
                sliceSize = sliceSize || 512;

                let byteCharacters = atob(b64Data);
                let byteArrays = [];

                for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                    let slice = byteCharacters.slice(offset, offset + sliceSize);

                    let byteNumbers = new Array(slice.length);
                    for (let i = 0; i < slice.length; i++) {
                        byteNumbers[i] = slice.charCodeAt(i);
                    }

                    let byteArray = new Uint8Array(byteNumbers);

                    byteArrays.push(byteArray);
                }

                return new Blob(byteArrays, {type: contentType});
            },
            /*#endregion*/

            /*#region Loader Functions*/
            showLoading() {
                this.$vs.loading();
            },

            hideLoading() {
                this.$vs.loading.close();
            },
            /*#endregion*/

            /*#region Scroll Loader Functions*/
            getScrollPercent() {
                let libDiv = $(".library-list-container")[0],
                    scrollTop = 'scrollTop',
                    scrollHeight = 'scrollHeight';

                // console.log(libDiv[scrollTop], "stop");
                // console.log(libDiv[scrollHeight], "sheight");
                // console.log(libDiv.clientHeight, "cheight");

                return (libDiv[scrollTop] + libDiv.clientHeight + 100) >= libDiv[scrollHeight];
            },

            isScrollable() {
                return $(document).height() > $(window).height();
            },

            debounce(func, wait, immediate) {
                // Returns a function, that, as long as it continues to be invoked, will not
                // be triggered. The function will be called after it stops being called for
                // N milliseconds. If `immediate` is passed, trigger the function on the
                // leading edge, instead of the trailing.
                let timeout, result;
                let self = this;

                let later = function (context, args) {
                    timeout = null;
                    if (args) result = func.apply(context, args);
                };

                let debounced = self.restArguments(function (args) {
                    if (timeout) clearTimeout(timeout);
                    if (immediate) {
                        let callNow = !timeout;
                        timeout = setTimeout(later, wait);
                        if (callNow) result = func.apply(this, args);
                    } else {
                        timeout = self.delay(later, wait, this, args);
                    }

                    return result;
                });

                debounced.cancel = function () {
                    clearTimeout(timeout);
                    timeout = null;
                };

                return debounced;
            },

            delay(func, wait, ...args) {
                // Lodash Delay
                /**
                 * Invokes `func` after `wait` milliseconds. Any additional arguments are
                 * provided to `func` when it's invoked.
                 *
                 * @since 0.1.0
                 * @category Function
                 * @param {Function} func The function to delay.
                 * @param {number} wait The number of milliseconds to delay invocation.
                 * @param {...*} [args] The arguments to invoke `func` with.
                 * @returns {number} Returns the timer id.
                 * @example
                 *
                 * delay(text => console.log(text), 1000, 'later')
                 * // => Logs 'later' after one second.
                 */
                if (typeof func != 'function') {
                    throw new TypeError('Expected a function');
                }
                return setTimeout(func, +wait || 0, ...args);
            },

            restArguments(func, startIndex) {
                // Some functions take a variable number of arguments, or a few expected
                // arguments at the beginning and then a variable number of values to operate
                // on. This helper accumulates all remaining arguments past the function?s
                // argument length (or an explicit `startIndex`), into an array that becomes
                // the last argument. Similar to ES6?s "rest parameter".
                startIndex = startIndex == null ? func.length - 1 : +startIndex;
                return function () {
                    let length = Math.max(arguments.length - startIndex, 0),
                        rest = Array(length),
                        index = 0;
                    for (; index < length; index++) {
                        rest[index] = arguments[index + startIndex];
                    }
                    switch (startIndex) {
                        case 0:
                            return func.call(this, rest);
                        case 1:
                            return func.call(this, arguments[0], rest);
                        case 2:
                            return func.call(this, arguments[0], arguments[1], rest);
                    }
                    let args = Array(startIndex + 1);
                    for (index = 0; index < startIndex; index++) {
                        args[index] = arguments[index];
                    }
                    args[startIndex] = rest;
                    return func.apply(this, args);
                };
            },
            /*#endregion*/

            /*#region show Drop Zone Functions*/
            showDropZone() {
                $("#div_DropZone").css({
                    "visibility": "visible",
                    "opacity": "1"
                });
            },
            hideDropZone() {
                $("#div_DropZone").css({
                    "visibility": "hidden",
                    "opacity": 0
                });
            },
            /*#endregion*/

            /*#region search files Functions*/
            searchFiles(event) {
                if (((!this.isNull(event) && event.keyCode === 13) || this.isNull(event))) {
                    this.arrobj_Files = [];
                    this.arr_searchFileList = [];
                    this.isSearch = true;

                    if (this.searchFilesTag === "") {
                        this.isSearch = false;
                        this.arrobj_FolderPath = [{GalFolder: lang("Library"), GalID: "PRIMARY", GalType: "Folder"}];
                        this.initFolder(this.arrobj_FolderPath[0]);
                    } else {
                        this.int_StartRowNo = 1;
                        this.int_EndRowNo = 20;

                        this.getSearchFiles();
                    }
                }
            },

            async getSearchFiles() {
                try {
                    this.showLoading();

                    const response = await DataSource.shared.getFiles('', this.int_StartRowNo, this.int_EndRowNo, this.searchFilesTag);
                    if (response) {
                        // if (response.code === "2") {

                        // }
                        // console.log(response, "response");

                        if (response.Table) {
                            this.arrobj_Files.push.apply(this.arrobj_Files, response.Table);
                            this.arr_searchFileList.push.apply(this.arr_searchFileList, response.Table);

                            this.int_StartRowNo = this.int_EndRowNo + 1;
                            this.int_EndRowNo = this.int_EndRowNo + 20;
                        }
                    }

                    this.hideLoading();
                } catch (e) {
                    this.results = e;
                }
            },
            /*#endregion*/

            /*#region change directory Functions*/
            changeSelectedFolder() {
                this.changeDirectory(this.selectedFolder);
            },

            changeDirectory(obj_Folder) {
                this.selectedFolder = {};
                this.arrobj_FolderPath.push(obj_Folder);

                this.initFolder(obj_Folder);
            },

            backSpecificDirectory(obj_Folder, i) {
                this.selectedFolder = {};
                let checkPop = i + 1;
                let obj_PreviousFolder = this.arrobj_FolderPath[i];
                this.initFolder(obj_PreviousFolder);

                let folderLength = this.arrobj_FolderPath.length;

                for (folderLength; folderLength > checkPop; folderLength--) {
                    if (this.arrobj_FolderPath.length !== checkPop) {
                        this.arrobj_FolderPath.pop();
                    }
                }
            },
            /*#endregion*/

            /*#region Show different modal Functions*/
            showModalType() {
                if (this.currentPage === "feed") {
                    if (this.arrobj_SelectedItem.length === 0) {
                        this.$notify.error({
                            title: 'Error',
                            message: 'Please select file(s)!'
                        });
                        return;
                    }
                }

                if (this.currentPage === "broadcast") {
                    this.showBroadcastModal();
                } else if (this.currentPage === "feed") {
                    this.showUpdateModal();
                }
            },

            showUpdateModal() {
                this.obj_SelectedComponent = updates;
                this.str_PostComponentTitle = "News Feed";
                this.showComponentModal();
            },

            showBroadcastModal() {
                this.obj_SelectedComponent = broadcast;
                this.str_PostComponentTitle = "Broadcast";
                this.showComponentModal();
            },

            displayResult(value) {
                switch (value) {
                    case "TRUE":
                        this.$notify({
                            title: lang('Success'),
                            message: lang('Successfully Posted'),
                            type: 'success'
                        });
                        // this.str_Result = "Successfully posted!";
                        break;
                    case "FALSE":
                        this.$notify.error({
                            title: lang('Error'),
                            message: lang('Whoops. Something went wrong. Please check your fields and try again.')
                        });
                        // this.str_Result = "Whoops. Something went wrong. Please check your fields and try again.";
                        break;
                }

                this.rerendarComponent();
                this.clearSelectedImage();
                this.hideComponentModal();
            },

            showComponentModal() {
                this.obj_ComponentProperties = {images: this.arrobj_SelectedItem};
                this.$refs.modal_PostComponent.show();
            },

            hideComponentModal() {
                this.obj_SelectedComponent = false;
                this.$refs.modal_PostComponent.hide();
            },
            /*#endregion*/

            rerendarComponent() {
                this.$emit("rerendarCurrentComponent", true);
            },

            grapeSelectedFiles() {
                this.$emit("paramSelectedFiles", this.arrobj_SelectedItem);
                this.clearSelectedImage();
            },

            mobileLibraryBack() {
                this.$emit("mobileLibrary", true);
            },

            clearSelectedImage() {
                this.arrobj_SelectedItem = [];
            },

            scrollToTop() {
                // $(".left-content-container").scrollTop();
                $(".library-list-container").scrollTop();
            },

            isNull(obj) {
                return (obj === null || obj === undefined || obj === "undefined" || obj.length === 0 || obj === "");
            },

            sleep(milliseconds) {
                return new Promise(resolve => setTimeout(resolve, milliseconds));
            },

            isMobile() {
                let screenWidth = window.innerWidth;
                if (screenWidth <= 770) {
                    this.checkMobileStatus = true;
                    // return true;
                } else {
                    this.checkMobileStatus = false;
                    // return false;
                }

                if (this.checkMobileStatus) {
                    this.isLeft = false;
                    this.isRight = false;
                } else {
                    this.isLeft = true;
                    this.isRight = true;
                }
            },

            generateVideoThumbnail(thumbnail) {
                var src = thumbnail; ///video url not youtube or vimeo,just video on server
                var video = document.createElement('video');

                video.src = src;

                video.width = 360;
                video.height = 240;

                var canvas = document.createElement('canvas');
                canvas.width = 360;
                canvas.height = 240;
                var context = canvas.getContext('2d');

                context.drawImage(video, 0, 0, canvas.width, canvas.height);
                var dataURI = canvas.toDataURL('image/jpeg');

                return dataURI;
            },

            triggerClickVideo(videoFile, itemID) {

                $(".video-thumbnail-" + itemID + " img").remove();

                var video = document.createElement('video');

                video.className = "video-thumb nonM card-img-top d-block img-fluid w-100";
                video.src = videoFile.FilePath;

                var videoHtml = "";
                videoHtml += "<video class='video-thumb nonM card-img-top d-block img-fluid w-100' style='object-fit: contain; margin: 20% 0px; height: 100%;' controls autoplay src='" + videoFile.FilePath + "' type='video/mp4' controlsList='nodownload'>";
                // videoHtml += "<source :src='"+videoFile.FilePath+"' type='video/mp4'>";
                videoHtml += "</video>";

                if ($(".video-thumbnail-" + itemID + " video").length <= 0) {
                    $(".video-thumbnail-" + itemID).append(videoHtml);
                }
            },

            /*#region Page tour*/
            libraryPageVueTourStart() {
                this.$tours['LibraryPageVueTourName'].start();
            },

            libraryPageVueTourCallBacksPreviousSteps(currentStep) {
                let finalSteps = currentStep - 1;
            },

            libraryPageVueTourCallBacksNextSteps(currentStep) {
                let finalSteps = currentStep + 1;
            },
            /*#endregion*/
        },
        mounted() {
            this.isMobile();

            const self = this;
            self.initFolder(self.arrobj_FolderPath[0]);
            self.loadWhitelist();
            self.scrollToTop();

            window.addEventListener('load', () => {
                if (this.$route.query.tour === 'library') {
                    self.libraryPageVueTourStart();
                }
            });

            /*#region upload files functions*/
            $("#fileUpload").off('change').on('change', function (e) {
                e.preventDefault();

                self.arr_SelectedFileList = [];
                self.arr_SelectedFileList = e.target.files;
                if (e.target.files.length > 5) {
                    self.$notify.error({
                        title: 'Error',
                        message: 'Upload files max allow 5 each time!'
                    });
                    return;
                }
                // self.showLoading();
                self.showFilesTagModal();
            });
            /*#endregion*/

            /*#region scroll load more functions*/
            $(".library-list-container").scroll(self.debounce(() => {
                // $(".left-content-container").scroll(self.debounce(() => {
                // $(window).scroll(self.debounce(() => {
                const listElm = document.querySelector('.left-content-container');
                if ((self.getScrollPercent() && listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight)) {
                    //     if (self.getScrollPercent() >= 80) {
                    let obj_CurrentFolder = self.arrobj_FolderPath[self.arrobj_FolderPath.length - 1];
                    if (self.searchFilesTag === "") {
                        self.getFiles(obj_CurrentFolder).then((result) => {
                            self.arrobj_Files.push.apply(self.arrobj_Files, result);
                        }).then(() => {
                            self.hideLoading();
                        });
                    } else {
                        self.getSearchFiles();
                    }
                }
            }, 250));
            /*#endregion*/
        },
        computed: {
            filteredSelectedItem: function () {
                return this.arrobj_SelectedItem;
                // return this.arrobj_SelectedItem.filter(x => this.isImage(x));
            }
        },
        watch: {
            changeCurrentPage: function (newVal, oldVal) { // watch it
                // console.log(newVal, "new");
                // console.log(oldVal, "old");

                this.currentPage = oldVal;

                if (newVal && newVal !== oldVal) {
                    this.currentPage = newVal;
                }
            }
        },
    };
</script>

<style scoped>
    ::-webkit-input-placeholder { /* Edge */
        color: #91A3B6;
    }

    :-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: #91A3B6;
    }

    ::placeholder {
        color: #91A3B6;
    }

    .selected-file {
        width: 40px;
        height: 40px;
        margin: 0px 5px 5px 0px;
    }

    .media-file:nth-child(odd) {
        min-height: inherit;
        border-radius: inherit;
        position: relative;
        width: calc(50% - 10px);
        height: 150px;
        display: inline-block;
        margin-right: 10px;
        margin-bottom: 10px;
    }

    .media-file:nth-child(even) {
        min-height: inherit;
        border-radius: inherit;
        position: relative;
        width: calc(50% - 10px);
        height: 150px;
        display: inline-block;
        margin-left: 10px;
        margin-bottom: 10px;
    }

    .media-file-image-container {
        min-height: inherit;
        border-radius: inherit;
        margin: 0px;
        max-height: 200px;
        text-align: center;
    }

    .media-file-image {
        cursor: pointer;
        width: 140px;
        height: 120px;
        object-fit: contain;
    }

    .media-file input[type='checkbox'] + label {
        width: 15px;
        height: 15px;
        position: absolute;
        margin: auto;
        box-sizing: border-box;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        text-indent: -999px;
        overflow: hidden;
        cursor: pointer;
        border: 2px solid #426DFF; /* #3c3956 */
        background: transparent !important;
        border-radius: 50% !important;
        -moz-border-radius: 50%;
        -webkit-border-radius: 50%;
        top: 5px;
        right: 5px;
    }

    .media-file input[type='checkbox'] + label:before {
        content: '';
        width: 12px;
        height: 12px;
        top: 0;
        left: 0;
        bottom: -60px;
        right: 0;
        position: absolute;
        margin: auto;
        background: #426DFF;
        border-radius: 50%;
        -moz-border-radius: 50%;
        -webkit-border-radius: 50%;
        transition: 0.2s ease all;
        -moz-transition: 0.2s ease all;
        -webkit-transition: 0.2s ease all;
    }

    .media-file input[type='checkbox']:checked + label:before {
        bottom: 0;
    }

    #library-left-container .row {
        margin: 0px;
        padding: 15px;
    }

    #library-left-container hr {
        margin: 0px;
    }

    .btn-publish {
        background: #EA4C89;
        border-radius: 5px;
        color: white;
        float: right;
        padding: 5px 20px;
    }

    .btn-library-search-icon {
        font-size: 14px;
        background: #F8FAFF;
        border: 1px solid #E1E6F0;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        color: #426DFF;
        border-left: none;
    }

    .library-search {
        background: #F8FAFF;
        font-size: 14px;
        border-right: none;
    }

    .library-search:focus {
        -webkit-box-shadow: none;
        box-shadow: none;
        border-color: #eee;
    }

    .library-list-container {
        /*height: 200px;*/
        overflow: auto;
        height: calc(100vh - 380px);
    }

    .library-list-container::-webkit-scrollbar {
        background-color: #fff;
        width: 8px;
    }

    .library-list-container::-webkit-scrollbar-thumb {
        background-color: #426DFF;
    }

    .library-list-container::-webkit-scrollbar-track {
        background-color: #ffffff;
    }

    .btn-moment-editor-file {
        background: #EA4C89;
        border-radius: 5px;
        color: white;
        padding: 5px 20px;
    }

    .sans-font-style-different-size {
        font-family: sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 18px;
    }

    .sans-font-style {
        font-family: sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
    }
</style>

<style>
    .library__dropdown.el-popover {
        background: #455EEE;
    }

    .library__dropdown.el-popper .popper__arrow {
        display: none;
    }
</style>